import React, { useEffect } from "react";

interface PatientsListResultsBarProps {
  isDarkMode: boolean;
  searchValue: string;
  includeTitanPatients: boolean;
  onIncludeTitanPatientsChange: (value: boolean) => void;
  hasResults: boolean;
  searchTitanEnabled?: boolean;
}

export default function PatientsListResultsBar({
  isDarkMode,
  searchValue,
  includeTitanPatients,
  onIncludeTitanPatientsChange,
  hasResults,
  searchTitanEnabled,
}: PatientsListResultsBarProps) {
  // Reset Titan search when search is cleared
  useEffect(() => {
    if (searchValue.trim() === "" && includeTitanPatients) {
      onIncludeTitanPatientsChange(false);
    }
  }, [searchValue, includeTitanPatients, onIncludeTitanPatientsChange]);

  // Only show when Titan is active
  if (!includeTitanPatients) {
    return null;
  }

  return (
    <div className="flex items-center justify-end px-1 py-2">
      <div
        className={`text-xs ${isDarkMode ? "text-gray-400" : "text-gray-500"}`}
      >
        {searchTitanEnabled ? (
          <span>
            💡 Search Titan is enabled in filters - Showing results from Titan
            database
          </span>
        ) : (
          <span>Showing results from Titan database</span>
        )}
      </div>
    </div>
  );
}
